import React from 'react';
import PropTypes from 'prop-types';
import { Button, CircularProgress, Tooltip } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import c from 'classnames';

import './_actionButton.scss';

const ActionButton = ({
                        title,
                        onClick,
                        to,
                        href,
                        className = '',
                        variant = 'primary',
                        disabled = false,
                        tooltip,
                        loading  = false,
                        startIcon,
                        endIcon
                      }) => {
  const btnClass = c('action-button', variant, className, {
    disabled,
    icon: !!startIcon,
    endIcon: !!endIcon
  });

  const isDisabled = disabled || loading;

  const btn = (
    <Button
      component={to ? RouterLink : 'button'}
      to={to || undefined}
      href={href || undefined}
      onClick={onClick}
      variant="contained"
      className={btnClass}
      disabled={isDisabled}
      startIcon={!loading ? startIcon : null}
      endIcon={!loading ? endIcon : null}
    >
      {!loading ? title : <CircularProgress className="load-spinner" size={20} />}
    </Button>
  );

  return tooltip ? (
    <Tooltip title={title}>
      <span className="action-button-tooltip">{btn}</span>
    </Tooltip>
  ) : (
    btn
  );
};

ActionButton.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  to: PropTypes.string,
  href: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'secondary', 'outlined', 'text']),
  disabled: PropTypes.bool,
  tooltip: PropTypes.bool,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  loading: PropTypes.bool,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node
};

export default ActionButton;